import { Box } from '@mui/material'
import { motion } from 'framer-motion'
import LogoMark from '../../assets/images/logos/logo_mark_pofsis_business.png'
import FooterMark from '../../assets/images/logos/pofsis_mark_footer.png'

const ease = [0.16, 1, 0.3, 1]

const mainMotion = {
	initial: { opacity: 0, y: 30 },
	animate: { opacity: 1, y: 0 },
	transition: { duration: 0.7, delay: 0.1, ease },
}

const footerMotion = {
	initial: { opacity: 0, y: 20 },
	animate: { opacity: 1, y: 0 },
	transition: { duration: 0.65, delay: 0.35, ease },
}

export const Preload = () => {
	return (
		<Box
			height="100%"
			width="100%"
			position="relative"
			display="flex"
			flexDirection="column"
			alignItems="center"
			justifyContent="center"
			sx={{ bgcolor: '#F5F5F5', overflow: 'hidden' }}
		>
			<Box
				component={motion.div}
				initial={mainMotion.initial}
				animate={mainMotion.animate}
				transition={mainMotion.transition}
				display="flex"
				flexDirection="column"
				alignItems="center"
			>
				<Box
					component="img"
					src={LogoMark}
					alt="POFSIS Business"
					sx={{
						width: { xs: 96, sm: 120 },
						height: { xs: 96, sm: 120 },
						display: 'block',
						objectFit: 'contain',
					}}
				/>
				<Box
					mt={{ xs: 2.5, sm: 3 }}
					display="flex"
					alignItems="baseline"
					sx={{
						fontFamily: '"Inter", sans-serif',
						fontSize: { xs: 18, sm: 22 },
						letterSpacing: '-0.02em',
						lineHeight: 1.2,
					}}
				>
					<Box component="span" sx={{ fontWeight: 700, color: '#111111' }}>
						pofsis
					</Box>
					<Box component="span" sx={{ fontWeight: 500, color: '#6B7A4E', ml: 0.75 }}>
						business
					</Box>
				</Box>
			</Box>

			<Box
				position="absolute"
				left={0}
				right={0}
				display="flex"
				justifyContent="center"
				sx={{ bottom: { xs: 28, sm: 36 } }}
			>
				<Box
					component={motion.div}
					initial={footerMotion.initial}
					animate={footerMotion.animate}
					transition={footerMotion.transition}
					display="flex"
					alignItems="center"
					sx={{ gap: '8px' }}
				>
					<Box
						component="img"
						src={FooterMark}
						alt=""
						sx={{ width: 16, height: 18, display: 'block', objectFit: 'contain' }}
					/>
					<Box
						component="span"
						sx={{
							fontFamily: '"Inter", sans-serif',
							fontSize: 13,
							fontWeight: 600,
							color: '#111111',
							letterSpacing: '-0.01em',
						}}
					>
						pofsis
					</Box>
				</Box>
			</Box>
		</Box>
	)
}
